export default __webpack_public_path__ + "static/media/nuvem.6f87614e.svg";